// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","spacer":"_3pJE","header":"_1tGX","filled":"_3D2f","inner":"_1IkC","logo":"CgSh","innerMobile":"C67y","call-me":"_1pig","empty":"SMyu","navDesktop":"_2DWu","popup":"_3V4l","linkActive":"_3Nb1","button":"_2U7O","actionButtonContainer":"_3Y_5","actionButton":"_1A-P","userButton":"_3WwK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingHeader/LandingHeader.scss
// module id = 3F0y
// module chunks = 0